<div class="card bg-base-100">
  <div class="card-body">
    <div class="flex justify-between items-center mb-4">
      @if (showOwner) {
        <app-user-card [userId]="userId"></app-user-card>
      } @else {
        <div>All Accounts</div>
      }

      @if (balances?.balance !== undefined) {
        <div
          class="text-lg font-semibold"
          [class.text-success]="(balances?.balance ?? 0) > 0"
          [class.text-error]="(balances?.balance ?? 0) < 0"
          [class.text-base-content]="(balances?.balance ?? 0) === 0">
          {{ balances?.balance ?? 0 | currency: 'USD' : 'symbol' : '1.2-2' }}
        </div>
      }
    </div>

    <!-- Accounts list -->
    @if (balances && balances.byAccount) {
      <div class="space-y-2">
        @for (
          account of balances.byAccount | keyvalue | sortAlphabeticallyKeyValue;
          track account.key
        ) {
          <div
            class="flex justify-between items-center py-3 px-4 bg-base-100 rounded-lg border">
            <div class="flex items-center gap-3 flex-1">
              @if (showUserCards && account.value?.owner?.id) {
                <app-user-card
                  [userId]="account.value.owner.id"
                  [userType]="account.value.owner.type"
                  type="card"
                  [small]="true">
                </app-user-card>
              }
              <div>
                <span class="font-medium">{{
                  account.value?.name || account.key
                }}</span>
                @if (showUserCards && account.value?.owner?.id) {
                  <div class="text-xs text-base-content/60">
                    {{ account.key }}
                  </div>
                }
              </div>
            </div>

            <div class="flex items-center gap-3">
              <span
                class="font-semibold"
                [class.text-success]="(account.value?.balance ?? 0) > 0"
                [class.text-error]="(account.value?.balance ?? 0) < 0"
                [class.text-base-content]="(account.value?.balance ?? 0) === 0">
                {{
                  account.value?.balance ?? 0
                    | currency: 'USD' : 'symbol' : '1.2-2'
                }}
              </span>

              <div class="flex gap-1">
                <button
                  class="btn btn-ghost btn-xs"
                  (click)="onViewDetails(account.key, account.value)"
                  title="View Details">
                  <fa-icon [icon]="faEye"></fa-icon>
                </button>
                <button
                  class="btn btn-ghost btn-xs"
                  (click)="onTransfer(account.key, account.value)"
                  title="Transfer Funds">
                  <fa-icon [icon]="faExchangeAlt"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
